import React, { useContext, useState } from 'react';
import { Event, increaseEventUnusedTicketsStats } from '../../../../../model/event';
import { Card } from '../../../../../components/Card/Card';
import { t } from '../../../../../locales/translate';
import { Stack } from '../../../../../components/Stack/Stack';
import { Button } from '../../../../../components/Button/Button';
import { Modal } from '../../../../../components/Modal/Modal';
import { FormForm } from '../../../../../components/Form/FormForm';
import { useAsyncIndicator } from '../../../../../util/util';
import { FormFileUpload } from '../../../../../components/Form/FileUpload/FormFileUpload';
import { runExternalCodesImport } from '../../../../../model/imports';
import { Spacer } from '../../../../../components/Spacer/Spacer';
import { ActivitiesContext } from '../../../../../components/Activities/Activities';

export function ExternalCodesUpload({ event }: { event: Event }): JSX.Element {
  const [showExternalCodeUploadModal, setShowExternalCodeUploadModal] = useState(false);
  const [file, setFile] = useState<File | null | undefined>(null);
  const [loading, run] = useAsyncIndicator({ handleError: true });
  const [duplicateCodes, setDuplicateCodes] = useState<string[]>([]);
  const duplicatesFound = duplicateCodes.length > 0;
  const { reloadActivities } = useContext(ActivitiesContext);

  return (
    <>
      <Card title={t.model.event.externalCodesUpload}>
        <Stack>
          <p>{t.model.event.externalCodesUploadDescription}</p>
          <Button title="upload" onClick={() => setShowExternalCodeUploadModal(true)} />
        </Stack>
      </Card>
      <Modal title={t.model.event.externalCodesUpload} open={showExternalCodeUploadModal}>
        {() => (
          <FormForm
            canSubmit={!!file}
            loading={loading}
            cancelButtonTitle={duplicatesFound ? t.model.event.close : undefined}
            hideSubmit={duplicatesFound}
            onClose={() => {
              setDuplicateCodes([]);
              setShowExternalCodeUploadModal(false);
            }}
            onSubmit={async () => {
              const importModifications = await run(runExternalCodesImport(event.id, file!));
              const newCodesCount = importModifications?.['new_codes'];
              const duplicateCodes = importModifications?.['duplicates'];
              setDuplicateCodes(duplicateCodes);
              event.salesStats && newCodesCount && increaseEventUnusedTicketsStats(event, newCodesCount);
              setFile(null);
              reloadActivities();
              setShowExternalCodeUploadModal(duplicateCodes.length > 0);
            }}
          >
            {duplicatesFound ? (
              <Stack>
                <p>{t.model.event.externalCodesUploadSuccessModalDescription(duplicateCodes)}</p>
                <div>
                  {duplicateCodes.map((duplicateCode) => (
                    <p key={duplicateCode}>{`${duplicateCode}`}</p>
                  ))}
                </div>
              </Stack>
            ) : (
              <Stack>
                <FormFileUpload required accept="text/csv" value={file} onChange={(file) => setFile(file)} />
                <Spacer />
              </Stack>
            )}
          </FormForm>
        )}
      </Modal>
    </>
  );
}
